import gpsApi, { setGpsToken, clearGpsToken } from "@/plugins/gpsApi";

const gpsAuthService = {
  async login(username, password) {
    const { data } = await gpsApi.post("/login", { username, password });
    setGpsToken(data.access_token);
    return data;
  },

  async logout() {
    try {
      await gpsApi.post("/logout");
    } finally {
      clearGpsToken();
    }
  },
};

export default gpsAuthService;
